export default __webpack_public_path__ + "static/media/img-0515-croatia-half-face.47ff751b.png";